var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountApple = function SvgAccountApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.238 6.706c.887 0 2-.6 2.662-1.4.6-.725 1.037-1.737 1.037-2.75 0-.137-.012-.275-.037-.387-.988.037-2.175.662-2.888 1.5-.562.637-1.075 1.637-1.075 2.662 0 .15.026.3.038.35.063.013.162.025.263.025M9.113 21.831c1.212 0 1.75-.812 3.262-.812 1.537 0 1.875.787 3.225.787 1.325 0 2.213-1.225 3.05-2.425.938-1.375 1.325-2.725 1.35-2.787-.087-.025-2.625-1.063-2.625-3.975 0-2.525 2-3.663 2.113-3.75-1.325-1.9-3.338-1.95-3.888-1.95-1.487 0-2.7.9-3.463.9-.825 0-1.912-.85-3.2-.85C6.488 6.969 4 8.994 4 12.819c0 2.375.925 4.887 2.063 6.512.974 1.375 1.825 2.5 3.05 2.5"
  })));
};
export default SvgAccountApple;